import {tr} from '../../translations';
import {OnBoardingListItem} from '../../interfaces/components/onboarding';

export const onboardingList: OnBoardingListItem[] = [
  {
    id: 0,
    image: require('../../assets/images/onboarding/onboard-1.png'),
    prevTitle: tr('onboarding.prevTitlePage1'),
    title: tr('onboarding.titlePage1'),
    subtitle: tr('onboarding.descriptionPage1'),
  },
  {
    id: 1,
    image: require('../../assets/images/onboarding/onboard-2.png'),
    title: tr('onboarding.titlePage2'),
    subtitle: tr('onboarding.descriptionPage2'),
  },
  {
    id: 2,
    image: require('../../assets/images/onboarding/onboard-3.png'),
    title: tr('onboarding.titlePage3'),
    subtitle: tr('onboarding.descriptionPage3'),
  },
  {
    id: 3,
    image: require('../../assets/images/onboarding/onboard-4.png'),
    title: tr('onboarding.titlePage4'),
    subtitle: tr('onboarding.descriptionPage4'),
  },
  {
    id: 4,
    image: require('../../assets/images/onboarding/onboard-5.png'),
    title: tr('onboarding.titlePage5'),
    subtitle: tr('onboarding.descriptionPage5'),
  },
];
